import type { ContactReportSummary, ContactSummary } from '../types/contact'
import type { ContactFilters } from '../store/contactStore'

const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1'

export async function fetchContacts(filters: ContactFilters): Promise<ContactSummary[]> {
  const params = new URLSearchParams()
  filters.species_buckets.forEach((b) => params.append('species_bucket', b))
  if (filters.min_status !== 'unconfirmed') params.set('min_status', filters.min_status)

  const res = await fetch(`${BASE}/contacts?${params.toString()}`)
  if (!res.ok) throw new Error('Failed to load contacts')
  return res.json()
}

export async function fetchContact(id: string): Promise<ContactSummary> {
  const res = await fetch(`${BASE}/contacts/${id}`)
  if (!res.ok) throw new Error('Contact not found')
  return res.json()
}

export async function fetchContactReports(token: string, contactId: string): Promise<ContactReportSummary[]> {
  const res = await fetch(`${BASE}/contacts/${contactId}/reports`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!res.ok) throw new Error('Failed to load this contact\'s individual reports')
  return res.json()
}
